import React from "react";
import { Header } from '../../Components/Layout/Header.jsx'
import { ObavijestiCasino } from '../../Components/Layout/ObavijestiCasino.jsx'
import { MetaTags } from '../../Components/Layout/MetaTags.jsx'
import { CasinoMaratonBanner } from '../../Components/Casino/CasinoMaraton/CasinoMaratonBanner.jsx'
import { CasinoMaratonSignIn } from '../../Components/Casino/CasinoMaraton/CasinoMaratonSignIn.jsx'
import { CasinoMaratonMyData } from '../../Components/Casino/CasinoMaraton/CasinoMaratonMyData.jsx'
import { CasinoMaratonInfo } from '../../Components/Casino/CasinoMaraton/CasinoMaratonInfo.jsx'
import { CasinoMaratonPrizeFund } from '../../Components/Casino/CasinoMaraton/CasinoMaratonPrizeFund.jsx'
import { GameDetails } from '../../Components/Game/GameDetails.jsx'
import { Game } from '../../Components/Game/Game.jsx'


export class BonusesCasinoMaraton extends React.Component {
    constructor(props) {
        super(props);

        this.setData = this.setData.bind(this);
        this.getData = this.getData.bind(this);
        this.setPlayer = this.setPlayer.bind(this);

        this.state = {
            info:null,
            igracJeLogiran: this.props.user,
            results:[],
            games:[],
            gameCategories:[],
            player:null, 
            resultsLoaded: false, 
            isIntroPeriod:null,
            finalResults: [], 
            activePlayers: 0,
            isFinished:null
        }
        casino.utils.createPageGoogleTagManagerEvent('Bonusi', 'Casino Maraton', 'casino', this.props.user);
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.showMenuFn(false);
        this.getData();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.user !== this.props.user && this.props.user != null && this.state.results) { 
           this.setPlayer();
        }
    }

    setPlayer() {
        let player = this.state.results.find(it => it.nickname == this.props.user.nadimak);
        if (player) this.setState({ player:player});
        this.chekckIfIntroPeriod();
    }

    getData() {
        this.props.showLoadingFn(true);
        var promises = Promise.all([casino.repos.gameRepo.list().then(this.props.unpackGamesListFn), casino.repos.categoryRepo.list().then(this.props.saveCategoriesFn),casino.repos.casinoBonusMaratonRepo.rezultati()]);
        this.dataPromises = casino.utils.makeCancelablePromise(promises);
        this.dataPromises.promise.then(this.setData, function (reason) { });
    }
    
    setData(data) {
        var [games, gameCategories, results ] = data;
        //results.info.uplaceno = true;
        //results.info.aktivnoOd = '2021-10-21 00:00:00.000';
        //results.info.aktivnoDo = '2021-10-24 00:00:00.000';
        this.setState({
            results: results.results,
            info: results.info, 
            resultsLoaded : true,
            games:games,
            gameCategories:gameCategories.items,
            finalResults: results.finalResults,/*  [{igracID:8047, igracIme:'Mirko', nagrada: 75, nagrada2: 25000},{igracID:2, igracIme:'Slavko', nagrada: 75,nagrada2: 1000},{igracID:3, igracIme:'Jozo', nagrada: 75,nagrada2: 500}],*/
            activePlayers: results.activePlayers
        });

        this.props.showLoadingFn(false);
        if (this.props.userChecked && this.props.user) this.setPlayer();
    }

    chekckIfIntroPeriod() {
        let today = new Date();
        let campaignStart = new Date(this.state.info?.aktivnoOd);
        let campaignStartNextDay = new Date(this.state.info?.aktivnoOd);
        campaignStartNextDay.setDate(campaignStartNextDay.getDate() + 1);
        
        this.setState({
            isIntroPeriod: this.state?.info?.joker ? this.dateWithoutTime(campaignStart).getTime() == this.dateWithoutTime(today).getTime() ||
                this.dateWithoutTime(campaignStartNextDay).getTime() == this.dateWithoutTime(today).getTime() :
                this.dateWithoutTime(campaignStart).getTime() == this.dateWithoutTime(today).getTime(),
            isFinished:  new Date().getTime() > new Date(this.state.info?.aktivnoDo).getTime()         
        });
    }

    dateWithoutTime(date) {
        date.setHours(0, 0, 0, 0);
        return date;
    }

    isMaratonStarted() {
        return new Date().getTime() > new Date(this.state.info?.aktivnoOd).getTime();
    }

    componentWillUnmount() {
        this.dataPromises.cancel();
        this.props.showLoadingFn(false);
    }

    render() { 
        return (
        <div>
            <MetaTags title="Bonusi - SuperSport CASINO" description="Casino Maraton u SuperSport CASINU!" />
            <Header key="header" {...this.state} {...this.props}></Header>
            <CasinoMaratonBanner info={this.state.info}/> 
            <div className='white-background'>     
                <div id="page-wrapper" className="max-width-70 margin-center no-padding-on-mobile">
                    {this.state.resultsLoaded && this.isMaratonStarted() && <span>
                        {(this.state.player == null || !this.props.user) && 
                        <CasinoMaratonSignIn {...this.state}  igracJeLogiran={this.props.user} />  }
                        {this.props.user && this.state.player != null && <CasinoMaratonMyData {...this.state} /> }
                    </span>}
                    <CasinoMaratonInfo/>
                        <CasinoMaratonPrizeFund brands={this.props.brands} {...this.state} />
                </div> 
            </div>
            <GameDetails loadGames={true} {...this.props} {...this.state} routePrefix="/promotions/casino-maraton"></GameDetails>
            <ObavijestiCasino {...this.props}></ObavijestiCasino>
        </div>);

    }
}